import { render } from "./licensing.vue?vue&type=template&id=e8308186"
import script from "./licensing.vue?vue&type=script&lang=js"
export * from "./licensing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__